import { compose, filter, groupBy, pathEq, prop, uniq, values } from 'ramda'

const getChildQuestionIds = (parentReference, allReplies) => {
  return uniq(
    allReplies
      .filter(pathEq(['question', 'parentReference'], parentReference)) //
      .reduce((ids, childReply) => {
        return [...ids, childReply.questionId, ...getChildQuestionIds(childReply.question.reference, allReplies)]
      }, [])
  )
}

export const formatBlockReplies = (replies, ignoreFilter) => {
  const mappedReplies = replies.map(reply => {
    if (reply.question.type.name !== 'block') return reply
    const questionIds = getChildQuestionIds(reply.question.reference, replies)

    return {
      ...reply,
      value: compose(
        values,
        groupBy(prop('blockIndex')),
        filter(reply => questionIds.includes(reply.questionId))
      )(replies)
    }
  })

  if (ignoreFilter) {
    return mappedReplies
  }
  return mappedReplies.filter(reply => [-1, null, undefined].includes(reply.blockIndex))
}
